import { render, staticRenderFns } from "./CourseDetailPopup.vue?vue&type=template&id=e3418176&scoped=true"
import script from "./CourseDetailPopup.vue?vue&type=script&lang=js"
export * from "./CourseDetailPopup.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailPopup.vue?vue&type=style&index=0&id=e3418176&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3418176",
  null
  
)

export default component.exports